import './help-button.scss';

import { Menu, MenuItem } from '@mui/material';

import { Modal } from 'components/Modal/Modal';
import { TurkeyIcon } from 'components/icons/TurkeyIcon';
import useDeviceType from 'hooks/useDeviceType';
import { labels } from 'locales/en.label';
import { useState } from 'react';
import { FaRegQuestionCircle } from 'react-icons/fa';
import { MdClose } from 'react-icons/md';
import { shouldShowTurkey } from 'utils/date-utils';

interface HelpButtonProps {
	toggleChat?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HelpButton = ({ toggleChat }: HelpButtonProps) => {
	const { isMobile } = useDeviceType();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const [isBubbleVisible, setIsBubbleVisible] = useState(true);
	const isMenuOpen = Boolean(anchorEl);
	const closeMenu = () => setAnchorEl(null);
	const showTurkey = shouldShowTurkey();

	return (
		<div className='help-button-container'>
			{showTurkey && isBubbleVisible && (
				<div className='chat-bubble'>
					Gobble, gobble, how can I help you?
					<div
						className='chat-bubble__close'
						onClick={(e) => {
							e.stopPropagation();
							setIsBubbleVisible(false);
						}}
					>
						<MdClose />
					</div>
				</div>
			)}
			<button
				type='button'
				className={`help-button ${showTurkey ? 'help-button--turkey' : ''}`}
				onClick={(e) => {
					if (showTurkey) {
						setIsBubbleVisible(false);
					}
					setAnchorEl(e.currentTarget);
				}}
			>
				{showTurkey ? (
					<TurkeyIcon size={isMobile ? 50 : 80} />
				) : (
					<>
						<div className='help-button__icon'>
							<FaRegQuestionCircle size={isMobile ? '13px' : '18px'} />
						</div>
						<span className='help-button__text'>Help</span>
					</>
				)}
			</button>
			<Menu
				anchorEl={anchorEl}
				open={isMenuOpen}
				onClose={closeMenu}
				anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
				transformOrigin={{ vertical: 'bottom', horizontal: 'right' }}
			>
				<MenuItem
					onClick={(e) => {
						window.location.href = `mailto:${labels.app.support_email}`;
						e.preventDefault();
						closeMenu();
					}}
				>
					Email Support
				</MenuItem>
				<MenuItem
					onClick={() => {
						setIsModalOpen(true);
						closeMenu();
					}}
				>
					Reset BestRev Data
				</MenuItem>
				<MenuItem
					onClick={() => {
						toggleChat?.(true);
						closeMenu();
					}}
				>
					{`Chat with ${labels.chat.title}`}
				</MenuItem>
			</Menu>
			<Modal
				isShown={isModalOpen}
				hide={() => setIsModalOpen(false)}
				isConfirmationModal
				headerText='Are You Sure?'
				cancelBtnText='Cancel'
				confirmBtnText='Reset'
				onConfirm={() => {
					localStorage.clear();
					window.location.reload();
				}}
				onCancel={() => setIsModalOpen(false)}
			>
				Resetting BestRev data will clear stored settings and log you out. Are
				you sure you want to proceed?
			</Modal>
		</div>
	);
};

export default HelpButton;
